import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = { class: "infographics-container" }
const _hoisted_3 = { class: "infographics-header-block text-center" }
const _hoisted_4 = { class: "infographics-logo" }
const _hoisted_5 = /*#__PURE__*/_createVNode("h1", null, "CONVORALLY", -1)
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "step-tab" }
const _hoisted_8 = { class: "step-content" }
const _hoisted_9 = { class: "box-container scrollable" }
const _hoisted_10 = { class: "templates-heading" }
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = { class: "search-wrap" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = { class: "search-board" }
const _hoisted_17 = { class: "element-wrap project-element" }
const _hoisted_18 = { class: "search-glass" }
const _hoisted_19 = { class: "col-md-6  align-self-center" }
const _hoisted_20 = { class: "search-text" }
const _hoisted_21 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_24 = { class: "templates-form " }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-md-7 align-self-center" }
const _hoisted_27 = { class: "templates-text " }
const _hoisted_28 = { class: "uppercase-text" }
const _hoisted_29 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_30 = { class: "col-md-5" }
const _hoisted_31 = { class: "form-img" }
const _hoisted_32 = { class: "templates-desc" }
const _hoisted_33 = { class: "templates-label" }
const _hoisted_34 = { class: "templates-label" }
const _hoisted_35 = { class: "correct-img" }
const _hoisted_36 = { class: "sign-label" }
const _hoisted_37 = { class: "step-move" }
const _hoisted_38 = { class: "step-prev" }
const _hoisted_39 = /*#__PURE__*/_createVNode("i", { class: "fas fa-chevron-left" }, null, -1)
const _hoisted_40 = { class: "step-next" }
const _hoisted_41 = /*#__PURE__*/_createVNode("i", { class: "fas fa-chevron-right" }, null, -1)
const _hoisted_42 = { class: "final-container" }
const _hoisted_43 = { class: "final-block" }
const _hoisted_44 = { class: "container" }
const _hoisted_45 = { class: "final-wrap" }
const _hoisted_46 = { class: "convorally-moto" }
const _hoisted_47 = { class: "italic" }
const _hoisted_48 = { class: "final-img-wrap" }
const _hoisted_49 = /*#__PURE__*/_createVNode("p", null, "www. ", -1)
const _hoisted_50 = /*#__PURE__*/_createVNode("p", null, ".com", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_P = _resolveComponent("P")
  const _component_TutorialStep = _resolveComponent("TutorialStep")

  return (_openBlock(), _createBlock("main", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("section", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("img", {
            src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/convoicon-blue.png`: 'timg/convoicon-blue.png' ,
            alt: ""
          }, null, 8, ["src"])
        ]),
        _hoisted_5,
        _createVNode("h2", null, _toDisplayString(_ctx.$t('project_manager_app')), 1),
        _createVNode(_component_P, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('project_manager_description')), 1)
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_TutorialStep)
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _createVNode("h3", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('my')) + " ", 1),
                _hoisted_11,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('templates')), 1)
              ]),
              _createVNode("p", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('access_your_templates_either_pre_made')) + " ", 1),
                _hoisted_12,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('forms_or_create_custom_forms')), 1)
              ]),
              _createVNode("img", {
                src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/board.png`: 'timg/board.png' ,
                alt: ""
              }, null, 8, ["src"])
            ]),
            _createVNode("div", _hoisted_13, [
              _createVNode("div", _hoisted_14, [
                _createVNode("div", _hoisted_15, [
                  _createVNode("div", _hoisted_16, [
                    _createVNode("div", _hoisted_17, [
                      _createVNode("img", {
                        src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/clipboard-multiple.png`: 'timg/clipboard-multiple.png' ,
                        alt: ""
                      }, null, 8, ["src"])
                    ]),
                    _createVNode("div", _hoisted_18, [
                      _createVNode("img", {
                        src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/eye-glass.png`: 'timg/eye-glass.png' ,
                        alt: ""
                      }, null, 8, ["src"])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_19, [
                  _createVNode("div", _hoisted_20, [
                    _createVNode("p", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('search_pre_made_forms_using_the')) + " ", 1),
                      _hoisted_21,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('form_name_projects_channels')) + ", ", 1),
                      _hoisted_22,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('or_sort_by_numerical_or')) + " ", 1),
                      _hoisted_23,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('alphabetical_order')) + ".", 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_24, [
              _createVNode("div", _hoisted_25, [
                _createVNode("div", _hoisted_26, [
                  _createVNode("div", _hoisted_27, [
                    _createVNode("p", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('tap')) + " ", 1),
                      _createVNode("strong", _hoisted_28, "+" + _toDisplayString(_ctx.$t('create_form')), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('to_create_a_new_questionnaire_from_scratch')) + ".", 1)
                    ]),
                    _createVNode("ul", null, [
                      _createVNode("li", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('add')) + " ", 1),
                        _createVNode("strong", null, "“" + _toDisplayString(_ctx.$t('title_of_the_form')) + "”", 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('and')) + " ", 1),
                        _createVNode("strong", null, "“" + _toDisplayString(_ctx.$t('description')) + "”", 1)
                      ]),
                      _createVNode("li", null, _toDisplayString(_ctx.$t('add_custom_questions')), 1),
                      _createVNode("li", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('validate_the_form_by_adding')) + ":", 1),
                        _hoisted_29,
                        _createVNode("small", null, _toDisplayString(_ctx.$t('checkbox_radio_select_datepicker_signature_pad_etc')), 1)
                      ])
                    ]),
                    _createVNode("p", null, _toDisplayString(_ctx.$t('tap_on_choose_edocs_to_load_automated_template_forms')), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_30, [
                  _createVNode("div", _hoisted_31, [
                    _createVNode("img", {
                      src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/detailed-clipboard.png`: 'timg/detailed-clipboard.png' ,
                      alt: ""
                    }, null, 8, ["src"]),
                    _createVNode("div", _hoisted_32, [
                      _createVNode("div", _hoisted_33, [
                        _createVNode("p", null, _toDisplayString(_ctx.$t('name')), 1)
                      ]),
                      _createVNode("div", _hoisted_34, [
                        _createVNode("p", null, _toDisplayString(_ctx.$t('date')), 1)
                      ]),
                      _createVNode("div", _hoisted_35, [
                        _createVNode("img", {
                          src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/correct.png`: 'timg/correct.png' ,
                          alt: ""
                        }, null, 8, ["src"])
                      ]),
                      _createVNode("div", _hoisted_36, [
                        _createVNode("p", null, _toDisplayString(_ctx.$t('sign')), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_37, [
            _createVNode("div", _hoisted_38, [
              _createVNode("a", {
                href: "javascript:void(0)",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redirectToStep3 && _ctx.redirectToStep3(...args)))
              }, [
                _hoisted_39
              ])
            ]),
            _createVNode("div", _hoisted_40, [
              _createVNode("a", {
                href: "javascript:void(0)",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.redirectToStep5 && _ctx.redirectToStep5(...args)))
              }, [
                _hoisted_41
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_42, [
      _createVNode("section", _hoisted_43, [
        _createVNode("div", _hoisted_44, [
          _createVNode("div", _hoisted_45, [
            _createVNode("div", _hoisted_46, [
              _createVNode("img", {
                src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/comment.png`: 'timg/comment.png' ,
                alt: ""
              }, null, 8, ["src"]),
              _createVNode("p", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('building_confidence_trust')) + " – ", 1),
                _createVNode("span", _hoisted_47, _toDisplayString(_ctx.$t('one_convo_at_a_time')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_48, [
              _hoisted_49,
              _createVNode("img", {
                src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/convorally-text.png`: 'timg/convorally-text.png' ,
                alt: ""
              }, null, 8, ["src"]),
              _hoisted_50
            ])
          ])
        ])
      ])
    ])
  ]))
}